<h3 mat-dialog-title>{{ "map.livestream.confirmDialog.title" | t }}</h3>
<mat-dialog-content>
  <p>{{ "map.livestream.confirmDialog.message" | t }}</p>
  <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="warn" mat-dialog-close>{{ "common.cancel" | t }}</button>
  <button
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    mat-button
    color="success"
    (click)="proceed()"
  >
    {{ "common.proceed" | t }}
  </button>
</mat-dialog-actions>
